import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { HomeComponent } from './home/home.component';
import { FancyComponent } from './fancy/fancy.component';
import { AuthGuard } from './auth.guard';
import { MatchComponent } from './match/match.component';
import { MatchActivitiesComponent } from './match-activities/match-activities.component';
import { AllMatchComponent } from './all-match/all-match.component';
import { FancyActivitiesComponent } from './fancy-activities/fancy-activities.component';
import { Home2Component } from './home2/home2.component';
import { MatchesListComponent } from './matches-list/matches-list.component';
import { SettingsComponent } from './settings/settings.component';
import { LivetvComponent } from './livetv/livetv.component';
import { DMatchesComponent } from './d-matches/d-matches.component';
import { TestFancyComponent } from './test-fancy/test-fancy.component';
import { ServerStatusComponent } from './server-status/server-status.component';
import { AddManualMatchComponent } from './add-manual-match/add-manual-match.component';
import { SetLimitComponent } from './set-limit/set-limit.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'home2', component: Home2Component, canActivate: [AuthGuard] },
  { path: 'match', component: MatchComponent, canActivate: [AuthGuard] },
  { path: 'addMatch', component: AddManualMatchComponent, canActivate: [AuthGuard] },
  { path: 'dMatch', component: DMatchesComponent, canActivate: [AuthGuard] },
  { path: 'allMatch', component: AllMatchComponent, canActivate: [AuthGuard] },
  { path: 'matches-list', component: MatchesListComponent, canActivate: [AuthGuard] },
  { path: 'match-activities/:id', component: MatchActivitiesComponent, canActivate: [AuthGuard] },
  { path: 'fancy-activities/:id/:sel', component: FancyActivitiesComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'fancy/:id', component: FancyComponent, canActivate: [AuthGuard] },
  { path: 'setLimit/:id/:sport', component: SetLimitComponent, canActivate: [AuthGuard] },
  { path: 'settings', component: SettingsComponent, canActivate: [AuthGuard] },
  { path: 'liveTv', component: LivetvComponent, canActivate: [AuthGuard] },
  { path: 'serverStatus', component: ServerStatusComponent, canActivate: [AuthGuard] },
  { path: 'testFancy/:id', component: TestFancyComponent, canActivate: [AuthGuard] },
  // { path: 'setting', component: SettingComponent, children: [
  //   { path: '', component: SettingDashboardComponent, canActivate: [Level1Guard] },
  //   { path: 'activeMatch', component: SettingActiveMatchComponent, canActivate: [Level1Guard] },
  //   { path: 'inactiveMatch', component: SettingInactiveMatchComponent, canActivate: [Level1Guard] }
  // ] },
  // { path: '**', component: FilenotfoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class AppRoutingModule { }
